import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Applications extends Endpoint {
  async all() {
    let url = new URL(`/api/applications`, API_URL)
    return this.request(url)
  }

  async one(id) {
    let url = new URL(`/api/applications/${id}`, API_URL)
    return this.request(url)
  }

  async search(query, campaign) {
    let url = new URL(`/api/applications`, API_URL)
    url.searchParams.set('query', query)
    url.searchParams.set('campaign', campaign)
    return this.request(url, {}, false)
  }
}
